import { Gift, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

interface BundlePopupPreviewProps {
  settings: {
    title?: string;
    description?: string;
    buyQuantity?: number;
    getQuantity?: number;
    buttonText?: string;
    buttonColor?: string;
    buttonTextColor?: string;
    backgroundColor?: string;
    textColor?: string;
    showOnLoad?: boolean;
    delay?: number;
  };
}

export const BundlePopupPreview = ({ settings }: BundlePopupPreviewProps) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div
        className="relative max-w-md w-full rounded-2xl shadow-2xl p-8 animate-scale-in"
        style={{
          backgroundColor: settings.backgroundColor || "#ffffff",
          color: settings.textColor || "#000000",
        }}
      >
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full transition"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center">
            <Gift className="h-8 w-8 text-white" />
          </div>
        </div>

        <h3 className="text-2xl font-bold text-center mb-2">
          {settings.title || "عرض خاص! 🎉"}
        </h3>
        
        <p className="text-center text-lg mb-6">
          {settings.description || `اشتري ${settings.buyQuantity || 2} واحصل على ${settings.getQuantity || 1} مجاناً!`}
        </p>

        <Button
          className="w-full text-lg py-6"
          style={{
            backgroundColor: settings.buttonColor || "#10b981",
            color: settings.buttonTextColor || "#ffffff",
          }}
        >
          {settings.buttonText || "احصل على العرض الآن"}
        </Button>
      </div>
    </div>
  );
};
